import { useState } from 'react';
import { useBreakpoints } from '../../../../bookings/util/useBreakpoints';
import { useSearchFilters } from '../filters/useSearchFilters';
import { FilterChoice } from '../types/FilterChoice';
import { renderLocationChoice } from '../types/LocationChoice';
import { SearchBarV2Desktop } from './SearchBarV2Desktop';
import { SearchBarV2Mobile } from './SearchBarV2Mobile';

export interface Props {
  className?: string;
  specialtyFocused?: boolean;
  locationFocused?: boolean;
  setExpanded?: Setter<boolean>;
  setSpecialtyFocused?: Setter<boolean>;
  setLocationFocused?: Setter<boolean>;
  isSearchMultiLine?: boolean;
  setIsSearchMultiLine?: Setter<boolean>;
  placeholder?: string;
  setSearchResultsSingleViewIsShowing: Setter<boolean>;
  searchResultsSingleViewIsShowing: boolean;
  showPlaceholder: boolean;
  setShowPlaceholder: Setter<boolean>;
}

export const renderNewQuery = (filters: FilterChoice): string => {
  const { topic, text } = filters;

  const { treatment, specialist, bulkBillingGp } = topic || {};

  if (text) return text;

  const topics = treatment ?? specialist;
  const suggestionType = bulkBillingGp ? 'Bulk Billing GP' : topics;

  return suggestionType ?? '';
};

export const NewSearchBar = ({
  setExpanded,
  setSpecialtyFocused,
  specialtyFocused,
  setIsSearchMultiLine,
  ...props
}: Props) => {
  const [filters] = useSearchFilters();
  const [specialtyValue, setSpecialtyValue] = useState(renderNewQuery(filters) ?? '');

  const [locationValue, setLocationValue] = useState(
    filters.location ? renderLocationChoice(filters.location) : '',
  );

  const isMobile = useBreakpoints().Small;

  return isMobile ? (
    <SearchBarV2Mobile
      specialtyValue={specialtyValue}
      locationValue={locationValue}
      onSpecialtyTextChange={setSpecialtyValue}
      specialtyFocused={specialtyFocused}
      setSpecialtyFocused={setSpecialtyFocused}
      setIsSearchMultiLine={setIsSearchMultiLine}
      setLocationValue={setLocationValue}
      {...props}
    />
  ) : (
    <SearchBarV2Desktop
      specialtyValue={specialtyValue}
      locationValue={locationValue}
      setSpecialtyValue={setSpecialtyValue}
      setLocationValue={setLocationValue}
      setSpecialtyFocused={setSpecialtyFocused}
      specialtyFocused={specialtyFocused}
      {...props}
    />
  );
};
